// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2n4EH","colCheckbox":"styles_colCheckbox__2WLE-"};